/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConfigurator = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17.5 2.737H9.015l4.889 4.89L2.929 18.6l1.414 1.415L15.318 9.04l2.828 2.828 4.243-4.243zm-3.657 2h2.829l2.889 2.89-1.415 1.414zM8.405 8.642l1.534 1.535-1.414 1.414-1.535-1.535a3.622 3.622 0 0 1-5.026-4.73l1.847 1.846a1.208 1.208 0 0 0 1.71-1.71L3.674 3.617a3.624 3.624 0 0 1 4.73 5.026zm4.412 7.24-1.463-1.463 1.414-1.414 1.463 1.464a3.622 3.622 0 0 1 5.026 4.73l-1.846-1.846a1.208 1.208 0 0 0-1.71 1.71l1.847 1.846a3.624 3.624 0 0 1-4.73-5.026z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgConfigurator as Configurator };
